'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtIsAlwaysOpen', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtIsAlwaysOpen: '@',
				diffObject: '=',
				disableHeader: '@'
			},
			link: function (scope, element, attrs) {
				scope.showHeader = true;
				attrs.$observe('pmtIsAlwaysOpen', function (newVal /*, oldVal*/) {
					scope.isAlwaysOpen = scope.$eval(newVal);
				});

				attrs.$observe('disableHeader', function (newVal /*, oldVal*/) {
					scope.showHeader = !scope.$eval(newVal);
				});
			},
			templateUrl: 'shared/dataPrinters/pmtIsAlwaysOpenView.html'
		};
	}
]);
